import { useSharedLinkBill, useSharedLinkInitialData } from '@hook/sharedLinkData';
import { useSharedLinkId, useSharedLinkResource } from '@hook/useSharedLinkResource';
import OrderBillPrintModal from '@module/orderBillPrintModal';
import SharedLinkState from '@module/sharedLinkState';
import { getOrderByOrderId } from '@storeData/order';
import { getStoreFeedbackConfig } from '@storeData/store';
import { getSettledTiming } from '@util/billPrint';
import { redirectToHome } from '@util/routerService';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

function InvoicePage() {
    const orderId = useSharedLinkId();
    const { configData } = useSelector((state: any) => state.store.storeData);
    const store = useSelector((state: any) => state);
    const languageData: any = store.languageKeywords
    const currentStoreId = store?.store?.storeData?.storeId || configData?.storeId;
    const [feedbackConfig, setFeedbackConfig] = useState<any>(null);
    const serverOrder = useSharedLinkInitialData('order', orderId);
    const serverBill = useSharedLinkBill(orderId);
    const initialData = useMemo(
        () => serverOrder
            ? { ...serverOrder, settledTiming: serverOrder.settledTiming || getSettledTiming(serverOrder) }
            : null,
        [serverOrder]
    );
    const { data: orderData, state: fetchState, retry } = useSharedLinkResource<any>({
        id: orderId,
        initialData,
        fetcher: async (id) => {
            const order: any = await getOrderByOrderId(id, currentStoreId, configData?.tenantId);
            order.settledTiming = getSettledTiming(order);
            return order;
        }
    });

    const translate = useCallback(
        (keyword: string, fallback: string) => languageData?.[keyword] || fallback,
        [languageData]
    );

    useEffect(() => {
        if (!orderData) {
            setFeedbackConfig(null);
            return;
        }
        let cancelled = false;
        getStoreFeedbackConfig(orderData.tenantId, orderData.storeId, orderData.id).then((config) => {
            if (!cancelled) setFeedbackConfig(config);
        }).catch((error) => {
            console.error("Feedback Config Error:", error);
            if (!cancelled) setFeedbackConfig(null);
        });

        return () => { cancelled = true; }
    }, [orderData])

    return (
        <div className="invoice-wrapper">
            {/* <OrderDetailModel
                orderData={orderData}
                handleClose={() => { }} /> */}
            {fetchState === 'ready' && orderData && <OrderBillPrintModal
                orderData={orderData}
                initialBill={serverBill}
                onExplore={Boolean(configData?.storeConfig?.basicConfig?.catalogue) ? redirectToHome : undefined}
            />}
            <SharedLinkState
                state={fetchState}
                onRetry={retry}
                onSecondaryAction={Boolean(configData?.storeConfig?.basicConfig?.catalogue) ? redirectToHome : undefined}
                loadingText={translate('Loading your invoice', 'Loading your invoice...')}
                notFoundText={translate('Order not found', 'This invoice is no longer available.')}
                errorText={translate("We couldn't load your invoice. Please check your connection and try again.", "We couldn't load your invoice. Please check your connection and try again.")}
                retryText={translate('Retry', 'Retry')}
                secondaryActionText={translate('Explore More Services & Products', 'Explore more services')}
            />
            {fetchState === 'ready' && Boolean(configData?.storeConfig?.basicConfig?.catalogue) && <div className="footer-btn-wrap invoice-btn-wrap">
                <button className='primary-btn border-btn' onClick={redirectToHome}>{languageData["Explore More Services & Products"] ? languageData["Explore More Services & Products"] : "Explore More"}</button>
                {feedbackConfig?.active && Boolean(feedbackConfig?.feedbackUrl) && (
                    <button className='primary-btn' onClick={() => window.open(feedbackConfig?.feedbackUrl, "_blank")}>{languageData["Share Feedback"] ? languageData["Share Feedback"] : "Share Feedback"}</button>
                )}
            </div>}
        </div>
    )
}

export default InvoicePage
